export default __webpack_public_path__ + "static/media/toggle-sliders-w.f00041b3.svg";